import React, { useMemo } from "react";

import useCheckPermission from "@fartherfinance/frontend/api/Authz/hooks/useCheckPermission";

import useAdvisorRequestAuth from "@src/multiCustodian/hooks/useAdvisorRequestAuth";

import FinOpsHorizontalNav from "./FinOpsHorizontalNav";
import FinOpsPermissionContext from "./FinOpsPermissionContext";

interface FinOpsLayoutProps {
  children: React.ReactNode;
}

const FinOpsLayout: React.FC<FinOpsLayoutProps> = ({ children }) => {
  const auth = useAdvisorRequestAuth();

  const hasUpdatePermission = useCheckPermission(
    {
      type: "FinOps",
      action: "update",
      id: "Farther",
    },
    auth
  );

  const canUpdate = useMemo(() => {
    return hasUpdatePermission.data?.authorized === true;
  }, [hasUpdatePermission.data]);

  return (
    <FinOpsPermissionContext.Provider value={canUpdate}>
      <FinOpsHorizontalNav>{children}</FinOpsHorizontalNav>
    </FinOpsPermissionContext.Provider>
  );
};

export default FinOpsLayout;
